<template>
  <div
    class="ticket-inbound-whatsapp-message"
    :id="`inbound-whatsapp-message-${inboundWhatsappMessage.id}`"
  >
    <loading-screen :is-loading="isSaving"></loading-screen>
    <errors :error-list="serverErrors"></errors>
    <bookmark-modal
      modelType="InboundWhatsappMessage"
      :modelId="inboundWhatsappMessage.id"
      :currentValue="inboundWhatsappMessage.bookmark"
    ></bookmark-modal>

    <transfer-modal
      :modal-id="'transfer-modal-inbound-whatsapp'"
      entry-type="inbound_whatsapp_message"
      :entry-id="inboundWhatsappMessage.id"
      @transferred="handleTransfer"
    />

    <div class="card shadow-none">
      <div class="card-body" :class="{ 'pb-0': collapsed }">
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header">
          <div class="tl-l">
            <div class="avatar-xs">
              <span
                class="avatar-title rounded bg-soft-primary text-primary font-size-16"
              >
                ?
              </span>
            </div>
          </div>
          <div class="tl-r">
            <div>
              <b>Inbound WhatsApp message</b>
              <!--                            <span class="name">{{ smsLog.agent.name }}</span> sent an SMS-->
            </div>
            <small>
              <i>{{ displayTimestamp(inboundWhatsappMessage.created_at) }}</i>
              <span v-if="inboundWhatsappMessage.include_in_incident_report && inboundWhatsappMessage.incident_report_timestamp" class="ml-2" style="color: #dc3545;">
                <i class="fa fa-clock-o mr-1"></i>
                Incident Report: {{ displayTimestamp(inboundWhatsappMessage.incident_report_timestamp) }}
              </span>
              <split-tracking-badge v-if="inboundWhatsappMessage.split_tracking" :split-tracking="inboundWhatsappMessage.split_tracking" />
            </small>
          </div>
          <div class="tl-actions" v-if="!disableActions">
            <a
              href="#"
              class="btn btn-link text-muted"
              @click.prevent="toggleCollapsed"
            >
              <i
                class="fa"
                :class="{
                  'fa-chevron-down': collapsed,
                  'fa-chevron-up': !collapsed,
                }"
              ></i>
            </a>

              <!-- Incident Report Badge - only show if there's an incident report -->
              <a v-if="incidentReport" href="#" class="btn btn-link text-muted pl-1 pr-1" @click.prevent="toggleIncidentReportInclusion">
              <span class="badge" :class="{
                'badge-success': inboundWhatsappMessage.include_in_incident_report,
                'badge-secondary': !inboundWhatsappMessage.include_in_incident_report
              }" style="font-size: 10px; padding: 5px 9px;">
                <i v-if="inboundWhatsappMessage.include_in_incident_report" class="fa fa-check-circle text-white mr-1"></i>
                <i v-else class="fa fa-times-circle text-white mr-1"></i>
                {{ inboundWhatsappMessage.include_in_incident_report ? 'Included in Incident Report' : 'Excluded from Incident Report' }}
              </span>
            </a>

            <!-- Escalation Reminder Badge - only show if escalated_at is null -->
            <a
              v-if="!inboundWhatsappMessage.escalated_at"
              href="#"
              class="btn btn-link text-muted pl-1 pr-1"
              @click.prevent="toggleNoEscalationNeeded"
            >
              <span
                class="badge"
                :class="{
                  'badge-warning': !inboundWhatsappMessage.no_escalation_needed,
                  'badge-secondary':
                    inboundWhatsappMessage.no_escalation_needed,
                }"
                style="font-size: 10px; padding: 5px 9px"
              >
                <i
                  v-if="!inboundWhatsappMessage.no_escalation_needed"
                  class="fa fa-bell text-white mr-1"
                ></i>
                <i v-else class="fa fa-bell-slash text-white mr-1"></i>
                {{
                  inboundWhatsappMessage.no_escalation_needed
                    ? "Won't send reminder"
                    : "Will Send Reminder"
                }}
              </span>
            </a>

            <a
              href="#"
              class="btn btn-link text-muted pl-1 pr-1"
              @click.prevent="openBookmarkModal"
            >
              <i
                class="fa fa-heart"
                :class="{
                  'text-danger': inboundWhatsappMessage.bookmark,
                }"
              ></i>
            </a>

            <b-dropdown
              variant="white"
              right
              toggle-class="text-muted pt-0 pr-0 pb-0"
            >
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item @click="openTransferModal">
                Transfer to other ticket
              </b-dropdown-item>

              <!-- <b-dropdown-item @click="requestDelete" variant="danger"
                >Delete</b-dropdown-item
              > -->

              <!-- Disabled delete button -->
              <b-dropdown-item disabled>Delete (Disabled)</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">From:</b>
            <span class="mr-2"
              >{{ processWhatsappPhoneNumber(inboundWhatsappMessage.from) }}
              <span v-if="inboundWhatsappMessage.profile_name"
                >({{ inboundWhatsappMessage.profile_name }})</span
              ></span
            >
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">To:</b>
            <span class="mr-2">{{
              processWhatsappPhoneNumber(inboundWhatsappMessage.to)
            }}</span>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div
          class="tl-wrapper tl-header"
          v-show="!collapsed"
          v-if="inboundWhatsappMessage.escalated_at"
        >
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">Teams reminder sent:</b>
            <span class="mr-2">{{
              displayTimestamp(inboundWhatsappMessage.escalated_at)
            }}</span>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r tl-r-message-body">
            {{ inboundWhatsappMessage.message }}

            <!-- Update to use decodedMediaUrls -->
            <div v-if="decodedMediaUrls.length" class="media-preview mt-2">
              <div
                v-for="(url, index) in decodedMediaUrls"
                :key="index"
                class="media-item"
              >
                <img
                  v-if="!isPdf(url)"
                  :src="url"
                  class="img-thumbnail cursor-pointer"
                  style="max-height: 200px; max-width: 200px"
                  @click="openImage(url)"
                />
                <div
                  v-else
                  class="pdf-icon-container cursor-pointer"
                  @click="openImage(url)"
                >
                  <i class="fa fa-file-pdf text-danger" style="font-size: 30px;"></i>
                  <div class="text-muted small mt-1">PDF Document</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- / tl-wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Dates from "../../../../../mixins/Dates";
import Forms from "../../../../../mixins/Forms";
import Tickets from "../../../../../mixins/Tickets";
import axios from "axios";
import eventBus from "../../../../../event-bus";
import BookmarkModal from "./BookmarkModal.vue";
import LoadingScreen from "../../../../../components/LoadingScreen.vue";
import SplitTrackingBadge from '../../../../../components/SplitTrackingBadge.vue';
import TransferModal from "./TransferModal.vue";

export default {
  props: ["inboundWhatsappMessage", "disableActions"],
  name: "TicketInboundWhatsappMessage",

  data() {
    return {
      collapsed: false,
      isSaving: false,
      serverErrors: [],
    };
  },

  created() {
    eventBus.$on("collapse-all", () => {
      this.collapsed = true;
    });
    eventBus.$on("expand-all", () => {
      this.collapsed = false;
    });
  },

  beforeDestroy() {
    eventBus.$off("collapse-all");
    eventBus.$off("expand-all");
  },


  computed: {
    ...mapGetters("ticketViewer", {
      ticket: "ticket",
      incidentReport: "incidentReport",
    }),

    decodedMediaUrls() {
      if (!this.inboundWhatsappMessage.media_urls) return [];

      // If it's already an array, return as is
      if (Array.isArray(this.inboundWhatsappMessage.media_urls)) {
        return this.inboundWhatsappMessage.media_urls;
      }

      // If it's a string with length, try to parse it
      if (
        typeof this.inboundWhatsappMessage.media_urls === "string" &&
        this.inboundWhatsappMessage.media_urls.length > 0
      ) {
        try {
          return JSON.parse(this.inboundWhatsappMessage.media_urls);
        } catch (e) {
          console.error("Failed to parse media_urls:", e);
          return [];
        }
      }

      return [];
    },
  },

  components: { BookmarkModal, LoadingScreen, TransferModal, SplitTrackingBadge },

  mixins: [Dates, Forms, Tickets],

  methods: {
    ...mapActions("ticketViewer", {
      reloadTicket: "reloadTicket",
    }),

    processWhatsappPhoneNumber(phoneNumber) {
      // remove 'whatsapp:' prefix
      return phoneNumber.replace("whatsapp:", "");
    },

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },

    openBookmarkModal() {
      this.$bvModal.show(
        "bookmark-modal-InboundWhatsappMessage-" +
          this.inboundWhatsappMessage.id
      );
    },

    toggleNoEscalationNeeded() {
      let vm = this;
      vm.isSaving = true;

      axios
        .post(
          API_BASE +
            "/tickets/" +
            this.ticket.id +
            "/inbound-whatsapp-messages/" +
            this.inboundWhatsappMessage.id +
            "/toggle-no-escalation-needed"
        )
        .then((r) => {
          vm.isSaving = false;
          // vm.inboundWhatsappMessage.no_escalation_needed = !vm.inboundWhatsappMessage.no_escalation_needed;
          vm.inboundWhatsappMessage.no_escalation_needed =
            r.data.no_escalation_needed;

          this.$notify.success({
            title: "Success!",
            message: `Escalation reminder ${
              vm.inboundWhatsappMessage.no_escalation_needed
                ? "disabled"
                : "enabled"
            }`,
          });
        })
        .catch((e) => {
          vm.isSaving = false;
          vm.notifyErrors(e);
        });
    },

    requestDelete() {
      let vm = this;
      swal({
        title: "Are you sure you want to delete this note?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete",
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          vm.delete();
        }
      });
    },

    delete() {
      let vm = this;
      vm.isSaving = true;
      axios
        .delete(
          API_BASE +
            "/tickets/" +
            this.ticket.id +
            "/inbound-whatsapp-messages/" +
            this.inboundWhatsappMessage.id
        )
        .then((r) => {
          vm.isSaving = false;
          vm.reloadTicket();
          this.$notify.success({
            title: "Success!",
            message: "Note deleted successfully",
          });
        })
        .catch((e) => {
          vm.isSaving = false;
          vm.notifyErrors(e);
        });
    },

    openImage(url) {
      window.open(url, "_blank");
    },

    isPdf(url) {
      if (!url) return false;
      return url.toLowerCase().endsWith('.pdf') || url.toLowerCase().includes('.pdf?');
    },

    // Transfer modal methods
    openTransferModal() {
      this.$bvModal.show("transfer-modal-inbound-whatsapp");
    },

    handleTransfer({ newTicketId }) {
      // Navigate to new ticket after successful transfer
      this.$router.push(`/tickets/${newTicketId}`);
    },

    toggleIncidentReportInclusion() {
      let vm = this;
      vm.isSaving = true;
      vm.serverErrors = [];
      
      axios
        .post(
          API_BASE + "/tickets/" + this.ticket.id + "/inbound-whatsapp-messages/" + this.inboundWhatsappMessage.id + "/toggle-include-in-incident-report"
        )
        .then((r) => {
          vm.isSaving = false;
          // Update the local inboundWhatsappMessage with the response data
          vm.inboundWhatsappMessage.include_in_incident_report = r.data.include_in_incident_report;
          if (r.data.incident_report_timestamp) {
            vm.inboundWhatsappMessage.incident_report_timestamp = r.data.incident_report_timestamp;
          }
          
          this.$notify.success({
            title: "Success!",
            message: `Inbound WhatsApp message ${r.data.include_in_incident_report ? 'included' : 'excluded'} from incident report`,
          });
        })
        .catch((e) => {
          vm.isSaving = false;
          vm.notifyErrors(e);
        });
    },
  },
};
</script>

<style lang="scss">
.ticket-inbound-whatsapp-message {
  .tl-r-message-body {
    white-space: pre-line;
  }

  .card {
    background-image: linear-gradient(#fef1e1, #fef1e1);
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .media-preview {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .media-item {
    flex: 0 0 auto;
  }

  .pdf-icon-container {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background-color: #f8f9fa;
    transition: background-color 0.2s;
  }

  .pdf-icon-container:hover {
    background-color: #e9ecef;
  }

  // Escalation Reminder Badge Styles
  .badge {
    border-radius: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    transition: all 0.2s ease;

    &.badge-warning {
      background-color: #ffc107;
      color: #212529;

      &:hover {
        background-color: #e0a800;
      }
    }

    &.badge-secondary {
      background-color: #6c757d;
      color: white;

      &:hover {
        background-color: #545b62;
      }
    }

    &.badge-success {
      background-color: #28a745;
      color: white;

      &:hover {
        background-color: #218838;
      }
    }
  }
}

</style>
